import React from 'react';
import {
    Tooltip,
    Typography,
    Grid,
    IconButton,
    InputBase
} from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import LocationOffIcon from '@material-ui/icons/LocationOff';
import ClearIcon from '@material-ui/icons/Clear';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import parse from 'autosuggest-highlight/parse';
import throttle from 'lodash/throttle';

function loadScript(src, position, id) {
    if (!position) {
        return;
    }

    const script = document.createElement('script');
    script.setAttribute('async', '');
    script.setAttribute('id', id);
    script.src = src;
    position.appendChild(script);
}

const autocompleteService = { current: null };

const useStyles = makeStyles((theme) => ({
    icon: {
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(2),
    },
    input: {
        //borderRadius: 4
    }
}));

const apiKey = "AIzaSyAgTIg7-iU8bfZ7-RVWB9_zE-6PnHkIGSE"

const Adresse = props => {

    const {
        setAdresse,
        selectedAdresse,
        node,
        showPos,
        updateShowPos
    } = props

    const classes = useStyles();
    const [value, setValue] = React.useState(selectedAdresse);
    const [inputValue, setInputValue] = React.useState('');
    const [options, setOptions] = React.useState([]);
    const loaded = React.useRef(false);

    if (typeof window !== 'undefined' && !loaded.current) {
        if (!document.querySelector('#google-maps')) {
            loadScript(
                `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places`,
                //`https://maps.googleapis.com/maps/api/place/textsearch/json?key=${apiKey}`,
                document.querySelector('head'),
                'google-maps',
            );
        }

        loaded.current = true;
    }

    const googleFetch = React.useMemo(
        () =>
            throttle((request, callback) => {
                autocompleteService.current.getPlacePredictions(request, callback);
            }, 200),
        [],
    );

    const setLocation = async (value) => {

        if (value) {
            const proxyUrl = 'https://cors-anywhere.herokuapp.com/';
            const targetUrl = `https://maps.googleapis.com/maps/api/place/details/json?fields=geometry&place_id=${value.place_id}`;
            const resp = await fetch(`${proxyUrl}${targetUrl}&key=${apiKey}`)
            const data = await resp.json();

            setAdresse({
                target: {
                    name: "adresse",
                    node: node,
                    value: {
                        ...value,
                        coordinates: { ...data.result.geometry.location },
                    }
                }
            })
        }
    }



    React.useEffect(() => {
        let active = true;

        if (!autocompleteService.current && window.google) {
            autocompleteService.current = new window.google.maps.places.AutocompleteService();
        }
        if (!autocompleteService.current) {
            return undefined;
        }

        if (inputValue === '') {
            setOptions(value ? [value] : []);
            return undefined;
        }

        googleFetch({ input: inputValue }, (results) => {
            if (active) {
                let newOptions = [];

                if (value) {
                    newOptions = [value];
                }

                if (results) {
                    newOptions = [...newOptions, ...results];
                }

                setOptions(newOptions);
            }
        });

        return () => {
            active = false;
        };
    }, [value, inputValue, googleFetch]);

    return (
        <Autocomplete
            getOptionLabel={(option) => (typeof option === 'string' ? option : option.description)}
            filterOptions={(x) => x}
            options={options}
            autoComplete
            includeInputInList
            filterSelectedOptions
            value={value}
            disableListWrap
            noOptionsText="Aucune adresse n'a été trouvée"
            onChange={(event, newValue) => {
                setOptions(newValue ? [newValue, ...options] : options);
                setValue(newValue);
                setLocation(newValue);
            }}
            onInputChange={(event, newInputValue) => {
                setInputValue(newInputValue);
            }}
            renderInput={(params) => (
                <InputBase
                    className={classes.input}
                    {...params}
                    ref={params.InputProps.ref}
                    fullWidth
                    startAdornment={
                        <Tooltip title="Afficher/Masquer la position" arrow>
                            <IconButton onClick={() => updateShowPos(!showPos)}>
                                {showPos ? <LocationOnIcon /> : <LocationOffIcon />}
                            </IconButton>
                        </Tooltip>
                    }
                    endAdornment={
                        <IconButton onClick={() => setValue("")}>
                            <ClearIcon style={{ color: "red" }} />
                        </IconButton>
                    }
                />
            )}
            renderOption={(option) => {
                const matches = option.structured_formatting.main_text_matched_substrings;
                const parts = parse(
                    option.structured_formatting.main_text,
                    matches.map((match) => [match.offset, match.offset + match.length]),
                );

                return (
                    <Grid container alignItems="center">
                        <Grid item>
                            <LocationOnIcon className={classes.icon} />
                        </Grid>
                        <Grid item xs>
                            {
                                parts.map((part, index) => (
                                    <span key={index} style={{ fontWeight: part.highlight ? 700 : 400 }}>
                                        {part.text}
                                    </span>
                                ))
                            }

                            <Typography variant="body2">
                                {option.structured_formatting.secondary_text}
                            </Typography>
                        </Grid>
                    </Grid>
                );
            }}
        />
    );
};

export default Adresse;